import Scope from "./Scope-container";

/**
 * Export the top level component TeamScope-container
 *
 * @version 0.0.1
 * @author Steve Hunley
 *
 */
export default Scope;
